export enum UserType {
  POLICE = "police",
  ADMIN = "admin",
  PRIVATE_INDIVIDUAL = "individual",
  REGISTRAR_1_PAYMENT = "registrar1payment",
  REGISTRAR_1_ASSESSMENT = "registrar1assessment",
  REGISTRAR_2 = "registrar2",
  PANEL = "panel",
  LAWYER = "lawyer",
  PRESIDENT = "president",
  BALIFF = "baliff",
}
